import React from 'react'
// @ts-ignore no types
import _ from 'lodash'
// @ts-ignore no types
import { Button } from '@adc/ui-adc'
// common/modules/auctionDetails/redirectToSparkOfferSite
import { useListingContext } from 'common/context/listing'
import RedirectToSparkOfferSite from '../../modules/auctionDetails/redirectToSparkOfferSite'

// TODO change to AutomationTarget from type @adc/ui-adc
type SparkOfferButtonTypes = {
  elmId: string
}
const sparkOfferFallBackURL = 'https://www.sparkoffer.com'
const SparkOfferButton = ({ elmId }: SparkOfferButtonTypes) => {
  const { listing } = useListingContext()
  const sparkOfferUrl =
    listing.external_identifiers?.find(
      (id: any) => id?.data_source === 'SYNDICATION_PROPERTY_URL'
    )?.external_identifier || sparkOfferFallBackURL
  return (
    <RedirectToSparkOfferSite sparkOfferUrl={sparkOfferUrl}>
      <Button role='primary' elmId={elmId}>
        Buy on SparkOffer
      </Button>
    </RedirectToSparkOfferSite>
  )
}

export default SparkOfferButton
